import type { ComponentType } from 'react';
import { Icon as IconData } from '@silvertours/common-landingpages-view';

import { IconWrapper } from './Icon.styles';
import { carTypeIcons, icons } from './iconComponents';
import { IconRules } from './rule/Icon';

export type IconProps = {
  content?: IconData;
  rules?: IconRules;
};

const contentIcons: Partial<Record<string, ComponentType>> = {
  ...icons,
  ...carTypeIcons,
};

export const Icon = ({ content, rules }: IconProps) => {
  if (!content) {
    return null;
  }

  const { color = 'current', indent = 0, size = 50 } = rules || {};
  const IconComponent = contentIcons[content.key];

  // The key comes from Contentful. A key without an entry renders nothing
  // instead of an empty wrapper.
  if (!IconComponent) {
    return null;
  }

  return (
    <IconWrapper color={color} size={size} indent={indent}>
      <IconComponent />
    </IconWrapper>
  );
};
